// Set by the prerenderer's init script before any page script runs (see
// vite-plugin-html-prerender/src/renderer.ts). It used to be inferred from #root having no child
// nodes, which is also what a real browser sees when a route's prerendered output is legitimately
// empty - a route whose whole content sits inside `NoPrerender` prerenders to nothing, so loading
// one directly convinced the app it was prerendering and it rendered nothing at all. Permanently,
// because this is resolved once at import.
const isPreRendering = (globalThis as unknown as Record<string, boolean | undefined>).__IS_PRERENDERING__ === true;

export default isPreRendering;
